import React from 'react';

import { Grid, Paper, Skeleton, Typography } from '@mui/material';
import ContractRequestsUi from '../contract/requests/contract-requests.ui';
import { RequestDto } from '../../../services/dtos/request.dto';

/**
 * Composant comportant les demandes de tous les contrats
 * @param props contient les loadeur ainsi que les contrats à traiter
 * @constructor
 */
export default function MyRequestsUi(props: { requests?: RequestDto[]; loading: boolean }) {
    // On boucle sur les contrats pour ressortir leurs données
    return (
        <Grid className="containerOnlineProcess" container spacing={3}>
            <Grid item xs={12} sx={{ marginTop: '10px' }}>
                <Typography variant="h4">Mes demandes</Typography>
            </Grid>
            {props.loading ? (
                <Grid item xs={12}>
                    <Skeleton variant="rectangular" height={250}></Skeleton>
                </Grid>
            ) : (
                <Grid item xs={12}>
                    <Paper className={'container-requests'}>
                        {/*Affichage des infos du contrat*/}
                        <ContractRequestsUi requests={props.requests} onOneContract={false} />
                    </Paper>
                </Grid>
            )}
        </Grid>
    );
}
